export default __webpack_public_path__ + "static/media/cert.f2d77c8a.png";